import { Button } from '@bloo-team/ui'
import { isFpSuggestion, type TriageSuggestion } from '../../lib/signal-ai'
import { DISPOSITION_LABEL } from '../../lib/signal-model'

/**
 * The AI triage suggestion card (demo only — lib/signal-ai). Sits under the
 * deterministic reason sentence and reads as a separate voice. Accept opens
 * the Close dialog prefilled; nothing is applied from here.
 */
export function AiTriageCard({
  suggestion,
  compact = false,
  onAccept,
  onNotHelpful,
}: {
  suggestion: TriageSuggestion
  /** Docked pane: two reasons, no evidence line. */
  compact?: boolean
  onAccept?: () => void
  onNotHelpful?: () => void
}) {
  const fp = isFpSuggestion(suggestion)
  const why = compact ? suggestion.why.slice(0, 2) : suggestion.why
  const e = suggestion.evidence
  return (
    <div className="sg-ai-card" data-tone={fp ? 'warn' : undefined} role="group" aria-label="AI triage suggestion">
      <div className="hud-row sg-ai-head">
        <span className="sg-ai-verdict">{DISPOSITION_LABEL[suggestion.disposition]}</span>
        {suggestion.confidence !== null ? <span className="hud-unit">{suggestion.confidence}% confidence</span> : null}
      </div>
      <ul className="sg-ai-why">
        {why.map((w) => (
          <li key={w}>{w}</li>
        ))}
      </ul>
      {compact ? null : (
        <p className="hud-unit sg-ai-evidence">
          read: {e.priorClosed} closed from this detection · {e.related} same-entity signal{e.related === 1 ? '' : 's'}
          {e.storylineScore !== null ? ` · storyline score ${e.storylineScore}` : ''}
        </p>
      )}
      <div className="hud-row sg-ai-acts">
        {onAccept && suggestion.disposition !== 'undetermined' ? (
          <Button variant="solid" size="sm" onPress={onAccept}>
            Accept → Close… <kbd className="sp-key">a</kbd>
          </Button>
        ) : null}
        {onNotHelpful ? (
          <Button variant="ghost" size="sm" tone="neutral" onPress={onNotHelpful}>
            Not helpful
          </Button>
        ) : null}
        <span className="hud-unit sg-ai-fine">demo suggestion · never applied automatically</span>
      </div>
    </div>
  )
}
